
import React from "react";

const CustomerGuide = () => {
  return (
    <div className="container mt-4">
      <h2>📘 TransformJet Customer Guide</h2>
      <p>This guide helps you understand how to use TransformJet's features with real-world examples.</p>

      <h4>🔧 Scenario 1: Create an AI Agent</h4>
      <p>Navigate to <strong>AI Agent Manager</strong> and click "Create". Fill in:</p>
      <ul>
        <li><strong>Agent Name:</strong> ChatSupportAI</li>
        <li><strong>Role:</strong> Support</li>
        <li><strong>Data Source:</strong> CRM Database</li>
        <li><strong>Prompt:</strong> "Respond to customer FAQs using CRM data"</li>
      </ul>

      <h4>🔄 Scenario 2: Build a Workflow</h4>
      <p>Go to <strong>Workflow Designer</strong>:</p>
      <ul>
        <li><strong>Workflow Name:</strong> Lead Onboarding</li>
        <li><strong>Steps:</strong> Assign sales rep → Send welcome email → Notify AI agent</li>
        <li><strong>Status:</strong> Draft or Active</li>
      </ul>

      <h4>📝 Scenario 3: Track Tasks</h4>
      <p>In <strong>Task Manager</strong>, you can create tasks like:</p>
      <ul>
        <li><strong>Task:</strong> Prepare pitch deck</li>
        <li><strong>Assign to:</strong> John (Sales)</li>
        <li><strong>Due date:</strong> Next Monday</li>
      </ul>

      <h4>📊 Scenario 4: Use the Dashboard</h4>
      <p>On the <strong>Dashboard</strong>, you'll see:</p>
      <ul>
        <li>Total active projects</li>
        <li>Task progress by team</li>
        <li>AI suggestions for bottlenecks</li>
      </ul>

      <h4>📤 Scenario 5: Export & Import Data</h4>
      <p>Every module has export/import buttons:</p>
      <ul>
        <li>Export your tasks as JSON or CSV</li>
        <li>Import pre-defined templates or data</li>
      </ul>

      <h4>🕘 Scenario 6: Rollback a Workflow Template</h4>
      <p>In <strong>Workflow Templates</strong> → Click "Rollback" to restore a previous version.</p>

      <h4>🕵️‍♀️ Scenario 7: View Rollback History</h4>
      <p>Navigate to <strong>Rollback History</strong> from the menu to see all past changes.</p>

      <h4>⚙️ Tips</h4>
      <ul>
        <li>Use filters to search by department or status</li>
        <li>Use AI Copilot for help: click bottom-right assistant icon</li>
        <li>Admin users can manage permissions from User Management</li>
      </ul>
    </div>
  );
};

export default CustomerGuide;
